module.exports = __webpack_public_path__ + "static/img/empty.9a5e458.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicService/empty.jpg
// module id = TA+5
// module chunks = 2